import { ModelSagres } from "@/types/model-sagres";

export class RespostaDetalheSerigy extends ModelSagres {
    id: number
    criterioAtributoId: number
    tipoAnaliseId: number
    cpfAuditor: string | null
    linkEvidencia: string
    txtAnalise: string | null
    ponto: boolean
    dhResposta: Date
    linkPrint: string

    constructor(obj?: any) {
        super()
        if (obj) {
            if (obj.id) this.id = obj.id
            if (obj.criterioAtributoId) this.criterioAtributoId = obj.criterioAtributoId
            if (obj.tipoAnaliseId) this.tipoAnaliseId = obj.tipoAnaliseId
            if (obj.cpfAuditor) this.cpfAuditor = obj.cpfAuditor
            if (obj.linkEvidencia) this.linkEvidencia = obj.linkEvidencia
            if (obj.txtAnalise) this.txtAnalise = obj.txtAnalise
            if (obj.ponto) this.ponto = obj.ponto
            if (obj.dhResposta) this.dhResposta = new Date(obj.dhResposta)
            if (obj.linkPrint) this.linkPrint = obj.linkPrint
        }
    }
}